import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export async function ClipAndUnClipFavouriteAddressAsync(
  addressId: number,
  isClipped: boolean,
  token: string,
  t: (key: string) => string 
): Promise<any> {
  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return Promise.reject("Offline");
  }
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(`${baseUrl}/api/AddressFavourites/ClipAndUnClipFavouriteAddressAsync`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        addressId,
        isClipped,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    // console.error("Error sending clip/unclip request:", error);
    throw error;
  }
}